<template>
  <div class="cmpy-reg">
    <el-form
      :model="ruleForm"
      :show-message="false"
      :rules="rules"
      ref="ruleForm"
      class="rules"
    >
      <div class="label-title">用户名</div>
      <el-form-item
        label
        name="用户名"
        prop="account"
        style="position: relative; margin-bottom: 10px"
      >
        <el-input
          type="text"
          placeholder="请输入您的用户名"
          v-model="ruleForm.account"
        >
          <i
            slot="prefix"
            class="iconfont icon-yonghuming"
            style="font-size: 17px; margin-left: 3px"
          ></i>
        </el-input>
        <span v-if="nameFlag" class="error-message">{{ nameMess }}</span>
      </el-form-item>
      <div class="label-title">企业名称</div>
      <el-form-item
        name="用户名"
        prop="companyName"
        style="position: relative; margin-bottom: 10px"
      >
        <el-input
          type="text"
          placeholder="请输入企业名称"
          v-model="ruleForm.companyName"
        >
          <i
            slot="prefix"
            class="iconfont icon-yonghuming"
            style="font-size: 17px; margin-left: 3px"
          ></i>
        </el-input>
        <span v-if="cmpyNameFlag" class="error-message">{{
          cmpyNameMess
        }}</span>
      </el-form-item>
      <div class="label-title">上传营业执照</div>
      <div class="photo-wrapper">
        <el-form-item
          label
          v-if="!businessLicenseUrl"
          prop="businessLicenseUrl"
        >
          <el-upload
            class="upload-demo"
            drag
            :auto-upload="false"
            :show-file-list="false"
            :multiple="true"
            action
            accept="image/*"
            :on-change="httpRequestNega"
            :limit="1"
            v-model="ruleForm.businessLicenseUrl"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <span v-if="busUrlFlag" class="error-message">{{ busUrlMess }}</span>
        </el-form-item>
        <div class="upload-img" @click="businessLicenseUrl = ''" v-else>
          <div class="img-content">
            <i class="el-icon-error"></i>
          </div>
          <img
            :src="`${baseUrl}/front/file/getImage?path=${businessLicenseUrl}`"
            alt=""
            class="img"
          />
        </div>
      </div>
      <div class="label-title">设置密码</div>
      <div v-if="isNoLook" class="pwd-img">
        <el-form-item
          label
          name="设置密码"
          prop="password"
          style="position: relative; margin-bottom: 6px"
        >
          <el-input
            type="password"
            placeholder="请输入您的密码"
            v-model="ruleForm.password"
            :prefix-icon="isNoLook ? 'el-icon-lock' : 'el-icon-unlock'"
          >
          </el-input>
          <span v-if="pwdFlag" class="error-message">{{ pwdMess }}</span>
        </el-form-item>
        <img
          src="../assets/image/nolook.png"
          alt=""
          class="look-no"
          @click="isNoLook = !isNoLook"
        />
      </div>
      <div v-if="!isNoLook" class="pwd-img">
        <el-form-item
          label
          name="设置密码"
          prop="password"
          style="position: relative; margin-bottom: 6px"
        >
          <el-input
            placeholder="请输入您的密码"
            v-model="ruleForm.password"
            :prefix-icon="isNoLook ? 'el-icon-lock' : 'el-icon-unlock'"
          >
          </el-input>
          <span v-if="pwdFlag" class="error-message">{{ pwdMess }}</span>
        </el-form-item>
        <img
          src="../assets/image/look.png"
          alt=""
          class="look-no"
          @click="isNoLook = !isNoLook"
        />
      </div>
      <div class="label-title">确认密码</div>
      <div v-if="isNoLook1" class="pwd-img">
        <el-form-item
          label
          name="确认密码"
          prop="againPwd"
          style="position: relative; margin-bottom: 6px"
        >
          <el-input
            type="password"
            placeholder="请再次输入您的密码"
            v-model="ruleForm.againPwd"
            :prefix-icon="isNoLook1 ? 'el-icon-lock' : 'el-icon-unlock'"
          >
          </el-input>
          <span v-if="agpwdFlag" class="error-message">{{ agpwdMess }}</span>
        </el-form-item>
        <img
          src="../assets/image/nolook.png"
          alt=""
          class="look-no"
          @click="isNoLook1 = !isNoLook1"
        />
      </div>
      <div v-if="!isNoLook1" class="pwd-img">
        <el-form-item
          label
          name="确认密码"
          prop="againPwd"
          style="position: relative; margin-bottom: 6px"
        >
          <el-input
            placeholder="请再次输入您的密码"
            v-model="ruleForm.againPwd"
            :prefix-icon="isNoLook1 ? 'el-icon-lock' : 'el-icon-unlock'"
          >
          </el-input>
          <span v-if="agpwdFlag" class="error-message">{{ agpwdMess }}</span>
        </el-form-item>
        <img
          src="../assets/image/look.png"
          alt=""
          class="look-no"
          @click="isNoLook1 = !isNoLook1"
        />
      </div>
      <el-form-item style="margin-bottom: 0; margin-top: 50px">
        <div class="btn">
          <el-button
            style="width: 100%"
            :loading="loading"
            type="primary"
            @click="submitForm()"
            >注册</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from 'axios';
import baseUrl from '../const/const';
export default {
  data () {
    let check = (rule, value, callback) => {
      console.log(rule)
      console.log(value)
      if (value === "") {
        if (rule.field == "account") {
          this.nameFlag = true;
          this.nameMess = "请输入您的用户名";
        } else if (rule.field == "companyName") {
          this.cmpyNameFlag = true;
          this.cmpyNameMess = "请输入企业名称";
        } else if (rule.field == "password") {
          this.pwdFlag = true;
          this.pwdMess = "请输入密码";
        } else if (rule.field == "againPwd") {
          this.agpwdFlag = true;
          this.agpwdMess = "请再次输入您的密码";
        } else if (rule.field == "businessLicenseUrl") {
          this.busUrlFlag = true;
          this.busUrlMess = "请上传营业执照";
        }
        return callback(new Error());
      } else {
        if (rule.field == "account") {
          this.nameFlag = false;
          this.nameMess = "";
        } else if (rule.field == "companyName") {
          this.cmpyNameFlag = false;
          this.cmpyNameMess = "";
        } else if (rule.field == "password") {
          this.pwdFlag = false;
          this.pwdMess = "";
        } else if (rule.field == "againPwd") {
          if (this.ruleForm.password != this.ruleForm.againPwd) {
            this.agpwdFlag = true;
            this.agpwdMess = "密码与确认密码不一致，请重新输入";
            return callback(new Error());
          } else {
            this.agpwdFlag = false;
            this.agpwdMess = "";
          }
        } else if (rule.field == "businessLicenseUrl") {
          this.busUrlFlag = false;
          this.busUrlMess = "";
        }
        callback();
      }
    };
    return {
      baseUrl: baseUrl,
      pwdFlag: false,
      agpwdFlag: false,
      cmpyNameFlag: false,
      busUrlFlag: false,
      nameFlag: false,
      isNoLook: true,
      isNoLook1: true,
      loading: false,
      ruleForm: {
        type: 2,
        account: "",
        companyName: '',
        password: "",
        againPwd: '',
        businessLicenseUrl: ''
      },
      businessLicenseUrl: '',
      rules: {
        account: [
          {
            required: true,
            trigger: "blur",
            validator: check
          }
        ],
        companyName: [
          {
            required: true,
            trigger: "blur",
            validator: check
          }
        ],
        businessLicenseUrl: [
          {
            required: true,
            trigger: "change",
            validator: check
          }
        ],
        password: [
          {
            required: true,
            trigger: "blur",
            validator: check
          }
        ],
        againPwd: [
          {
            required: true,
            trigger: "blur",
            validator: check
          }
        ]
      },
    }
  },
  async mounted () {
  },
  methods: {
    // 上传图片
    httpRequestNega (file) {
      var fd = new FormData()
      fd.append('file', file.raw)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      axios.post(`${baseUrl}/front/file/uploadImage`, fd, config) // 园区基地都是4
        .then(({ data }) => {
          let type = ''
          if (data.success) {
            type = 'success'
            this.businessLicenseUrl = data.data
          } else {
            type = 'error'
          }
          this.$message({
            message: data.mesg,
            type: type
          })
          this.loading = false
        })

    },
    submitForm () {
      this.loading = true;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.ruleForm.password != this.ruleForm.againPwd) {
            this.agpwdFlag = true;
            this.agpwdMess = "密码与确认密码不一致，请重新输入";
          } else {
            this.agpwdFlag = false;
            this.agpwdMess = "";
            this.ruleForm.businessLicenseUrl = `${baseUrl}/front/file/getImage?path=${this.businessLicenseUrl}`
            let config = {
              headers: {
                'Content-Type': 'application/json;charset=UTF-8'
              }
            }
            axios.post(`${baseUrl}/front/user/register`, this.ruleForm, config) // 园区基地都是4
              .then(({ data }) => {
                let type = ''
                if (data.success) {
                  type = 'success'
                  this.$router.push({
                    path: '/login'
                  })
                } else {
                  type = 'error'
                }
                this.$message({
                  message: data.mesg,
                  type: type
                })
                this.loading = false
              })

          }
          this.loading = false
        } else {
          this.loading = false
        }
      });
    },
  }
}
</script>

<style lang="stylus">
.cmpy-reg {
  .el-input {
    font-size: 30px !important;

    .el-input__prefix, .el-input__suffix {
      top: 4px;
    }

    .el-input__icon {
      .el-icon-lock, el-icon-unlock {
        line-height: 48px;
      }
    }
  }

  .photo-wrapper {
    .upload-img {
      position: relative;
      background-color: #f5f5f5 !important;
      border: 2px dashed #099CD5 !important;
      border-radius: 0;
      width: 100%;
      height: 180px;
      margin-bottom: 20px !important;

      .img-content {
        position: absolute;
        top: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.2);
        cursor: pointer;

        .el-icon-error {
          font-size: 30px;
          color: red;
        }
      }

      .img {
        width: 100%;
        height: 180px;
      }
    }

    .el-upload {
      width: 100%;

      .el-upload-dragger {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #f5f5f5 !important;
        border: 2px dashed #099CD5 !important;
        border-radius: 0;

        .el-icon-plus {
          font-size: 50px;
          color: #AAAAAA;
        }
      }
    }
  }
}

.cmpy-reg {
  padding: 10px 20px;

  .el-form {
    width: 100%;

    .label-title {
      font-family: PingFangSC-Regular;
      font-size: 20px;
      color: #333333;
      letter-spacing: 0;
      margin-bottom: 10px;
      margin-left: 32px;
    }

    .pwd-img {
      position: relative;

      .look-no {
        position: absolute;
        top: 9.5px;
        right: 15px;
        width: 40px;
        height: 29px;
        z-index: 10;
      }
    }

    .el-form-item {
      width: 100%;
      margin-bottom: 20px !important;

      .el-input {
        position: relative;
        width: 100%;
        height: 48px;

        .el-input__inner {
          height: 48px;
          line-height: 48px;
          font-size: 16px;
          padding-left: 35px;
        }
      }

      .error-message {
        position: absolute;
        top: 0;
        right: 60px;
        color: red;
        font-size: 16px;
        line-height: 48px;
      }

      .btn {
        margin: 0 auto;
        display: flex;
        justify-content: center;

        .el-button {
          width: 500px !important;
          height: 48px;
          font-family: PingFangSC-Regular;
          font-size: 20px;
          color: #FFFFFF;
          letter-spacing: 0;
          text-align: center;
          background: #516380;
          border-radius: 4px;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>